import { IconButton, BookmarkFilledIcon as bookmarkFilledIcon } from '@/shared/ui';
import useButtonAddEcgBookmark from './useButtonAddEcgBookmark';

/**
 * Renders the Add a bookmark toolbar button for the HR summary tab. Wires its click straight to the onClickAddBookmark callback supplied by useButtonAddEcgBookmark and draws a filled bookmark icon beside the label.
 *
 * @returns The bookmark icon button labelled Add a bookmark.
 */
const ButtonAddEcgBookmark = () => {
  const { onClickAddBookmark } = useButtonAddEcgBookmark();

  return (
    <IconButton
      id="bookmarkBtn"
      isFilledIconWithText
      className="add-bookmark-btn"
      iconComponent={<img src={bookmarkFilledIcon} alt="bookmark icon" />}
      onClick={onClickAddBookmark}
      iconText="Add a bookmark"
    />
  );
};

export default ButtonAddEcgBookmark;
